import { Button } from '@thinkific/chalk';
import { Icon } from '@thinkific/chalk/react-icons';
import { t } from 'i18next';
import React, { useRef } from 'react';

interface AttachmentInputProps {
  accept: string;
  ariaControls: string;
  icon: Icon;
  multiple?: boolean;
  onFileSelected: (files: File[]) => void;
  onBtnClicked: () => void;
}

const AttachmentInput = ({
  accept,
  ariaControls,
  icon,
  multiple = false,
  onFileSelected,
  onBtnClicked,
}: AttachmentInputProps) => {
  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const files = Array.from(event.target.files || []);

    // clear the input value, so that the same file can be uploaded again
    if (inputRef.current) {
      inputRef.current.value = '';
    }

    if (files) {
      onFileSelected(files);
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <Button
        data-qa="attachment-file-picker__button"
        emphasis="low"
        icon={icon}
        size="sm"
        hiddenLabel
        onClick={() => {
          if (inputRef.current) {
            inputRef.current.click();
          }
          onBtnClicked();
        }}
      >
        {t('Attachment', 'Attachment')}
      </Button>
      <input
        accept={accept}
        aria-controls={ariaControls}
        data-qa="attachment-file-picker__input"
        multiple={multiple}
        ref={inputRef}
        style={{ display: 'none' }}
        type="file"
        onChange={handleFileChange}
      />
    </>
  );
};

export default AttachmentInput;
